module.exports = "<li ng-if=\"$ctrl.isEditing()\">\n    <a class=\"c-nav__list-item__anchor / t-navigation-link\" ng-click=\"$ctrl.stopEditing()\">Logout</a>\n</li>\n";


//////////////////
// WEBPACK FOOTER
// ./frontend/storefront/app/modules/widget/views/stopEditing.menu.html
// module id = 797
// module chunks = 0